import { useCallback } from 'react';
import { withProps } from 'recompose';
import withFilteredLeaderBoards from '../reducers/withFilteredLeaderBoards';
import boards from '../reducers/boards';
import { usePortletConfig } from 'js/components/system/Portlet';

export default withProps(
    () => {
        const { portletType } = usePortletConfig();
        const reducer = useCallback((state, action) => withFilteredLeaderBoards({ portletType })(boards)(state, action),
            [portletType]
        );

        return {
            reducer
        };
    }
);
